import type { SVGProps } from 'react'
const SvgSyPlus = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g fillRule="evenodd" clipRule="evenodd">
			<path
				d="M12.75 8.327a.75.75 0 0 0-1.5 0v2.913H8.333a.75.75 0 0 0 0 1.5h2.917v2.913a.75.75 0 0 0 1.5 0V12.74h2.917a.75.75 0 0 0 0-1.5H12.75z"
				opacity={0.4}
			/>
			<path d="M7.314 1.25c-1.81 0-3.365.661-4.431 1.805S1.25 5.793 1.25 7.585v8.83c0 1.791.564 3.386 1.629 4.53s2.62 1.805 4.435 1.805h9.372c1.814 0 3.37-.66 4.435-1.805 1.065-1.144 1.629-2.739 1.629-4.53v-8.83c0-1.791-.564-3.386-1.629-4.53s-2.62-1.805-4.435-1.805zm0 1.5h9.372c1.461 0 2.565.496 3.337 1.326s1.227 2.03 1.227 3.51v8.828c0 1.48-.454 2.68-1.227 3.51-.772.83-1.876 1.326-3.337 1.326H7.314c-1.461 0-2.565-.496-3.337-1.326s-1.227-2.03-1.227-3.51V7.586c0-1.48.456-2.68 1.23-3.51.775-.83 1.878-1.326 3.334-1.326" />
		</g>
	</svg>
)
export default SvgSyPlus
